import { render, staticRenderFns } from "./IndicatorDetailsDialog.vue?vue&type=template&id=bd7e3454&scoped=true&"
import script from "./IndicatorDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./IndicatorDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorDetailsDialog.vue?vue&type=style&index=0&id=bd7e3454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7e3454",
  null
  
)

export default component.exports